<template>
  <div class="w-full h-64 flex items-center justify-center">
    <Pie
      v-if="data && !loading"
      :data="data"
      :options="{
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          legend: {
            position: 'right',
          },
        },
      }"
    />
    <LoadingSpinner v-else />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { Pie } from "vue-chartjs";

import LoadingSpinner from "@/components/LoadingSpinner.vue";

const props = defineProps({
  stats: { type: Object },
  loading: { type: Boolean, required: true },
});

const data = computed(() => {
  if (!props.stats) {
    return;
  }
  return {
    labels: Object.keys(props.stats).map((key) => getLabel(key)),
    datasets: [
      {
        label: "Count",
        backgroundColor: [
          "#DF4150",
          "#629AFE",
          "#FFD560",
          "#43C599",
          "#364053",
        ],
        data: Object.values(props.stats),
      },
    ],
  };
});

function getLabel(key) {
  // example: changes tone_or_quality to Tone / Quality
  return key
    .replace(/_or_/g, " / ") // change '_or_' to ' / '
    .replace(/_/g, " ") // change '_' to ' '
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize first letter
}
</script>
